export default "__VITE_PUBLIC_ASSET__53cd1834__"